import { Button, Dropdown } from 'antd';
import { TableOutlined } from '@ant-design/icons';
import type { Editor } from '@tiptap/react';
import type { MenuProps } from 'antd';
import { useIsMobile } from '../../hooks/useIsMobile';
import { withTip } from './ToolbarButton';

/** 表格操作：插入表格＋增刪列／欄（僅在表格內顯示對應項目）。 */
export default function TableControls({ editor, inTable }: { editor: Editor; inTable: boolean }) {
  const mobile = useIsMobile();
  const c = () => editor.chain().focus();
  const items: MenuProps['items'] = [
    { key: 'insert', label: '插入表格（3×3）', onClick: () => c().insertTable({ rows: 3, cols: 3, withHeaderRow: true }).run() },
    ...(inTable
      ? [
          { type: 'divider' as const },
          { key: 'addColAfter', label: '右側插入欄', onClick: () => c().addColumnAfter().run() },
          { key: 'addColBefore', label: '左側插入欄', onClick: () => c().addColumnBefore().run() },
          { key: 'delCol', label: '刪除欄', danger: true, onClick: () => c().deleteColumn().run() },
          { type: 'divider' as const },
          { key: 'addRowAfter', label: '下方插入列', onClick: () => c().addRowAfter().run() },
          { key: 'addRowBefore', label: '上方插入列', onClick: () => c().addRowBefore().run() },
          { key: 'delRow', label: '刪除列', danger: true, onClick: () => c().deleteRow().run() },
          { type: 'divider' as const },
          { key: 'toggleHeader', label: '切換表頭列', onClick: () => c().toggleHeaderRow().run() },
          { key: 'delTable', label: '刪除整個表格', danger: true, onClick: () => c().deleteTable().run() },
        ]
      : []),
  ];

  return (
    <Dropdown menu={{ items }} trigger={['click']}>
      {withTip(
        mobile,
        '表格',
        <Button
          size={mobile ? 'middle' : 'small'}
          type={inTable ? 'primary' : 'text'}
          aria-label="表格"
          icon={<TableOutlined />}
        />,
      )}
    </Dropdown>
  );
}
